var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-map ml-4 mr-4" }, [
    _vm.type === "create"
      ? _c(
          "div",
          [
            _c("div", { staticClass: "row py-3 align-items-center" }, [
              _c("div", { staticClass: "col company-h1" }, [
                _c("button", {
                  staticClass: "btn btn-back",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-info")
                    }
                  }
                }),
                _vm._v("\n        Create Company\n      ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ld-ext-right",
                    class: _vm.loadingButton ? "running" : "",
                    attrs: { type: "button", disabled: _vm.buttonDisabled }
                  },
                  [
                    _vm._v("\n          Save\n          "),
                    _c("div", { staticClass: "ld ld-ball ld-flip" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("companies-steps-menu", { attrs: { type: "create" } })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "edit"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "row py-3 align-items-center company-header" },
            [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("h2", { staticClass: "company-h1 mr-3" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/companies")
                        }
                      }
                    }),
                    _vm._v(
                      "\n          " + _vm._s(_vm.company.name) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.company.status
                    ? [
                        _vm.company.status.name === "Active"
                          ? _c("span", { class: "btn-status btn-active" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Inactive"
                          ? _c("span", { class: "btn-status btn-closed" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Setup Incomplete"
                          ? _c(
                              "span",
                              { class: "btn-status btn-ncover info-company" },
                              [
                                _vm._v(
                                  _vm._s(_vm.company.status.name) +
                                    "\n            "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn btn-link p-0 tippy-popup tippy-info",
                                    on: {
                                      mouseover: function($event) {
                                        _vm.showTooltipPrefix = true
                                      },
                                      mouseout: function($event) {
                                        _vm.showTooltipPrefix = false
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-info-circle"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.showTooltipPrefix
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "popover tippy-info-popover"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-8 d-flex align-items-center justify-content-end"
                },
                [
                  _vm.$_can("companies.review.request")
                    ? _c("companies-visibility-bar", {
                        attrs: { company: _vm.company },
                        on: {
                          saved: function($event) {
                            _vm.$emit("saved")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right ml-5",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { type: "button", disabled: _vm.buttonDisabled },
                      on: { click: _vm.save }
                    },
                    [
                      _vm._v("\n          Save\n          "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3 w-100" }, [
      _c("h5", { staticClass: "companies-sub-page-title" }, [
        _vm._v("Company licence")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "description-text" }, [
        _vm._v(
          "\n      Please provide your company's licence number and add a comment if you wish to provide additional information.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row l-m-b-16" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("h2", { staticClass: "l-header-2" }, [_vm._v("Licence details")]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Licence number")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.licence.licence_number,
                        expression: "licence.licence_number"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      autocomplete: "no",
                      placeholder: "Enter licence number",
                      disabled: !_vm.$_can("companies.update")
                    },
                    domProps: { value: _vm.licence.licence_number },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.licence,
                          "licence_number",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "licence_number" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Expiration date")]),
                    _vm._v(" "),
                    _c("flat-pickr", {
                      staticClass: "form-control",
                      attrs: {
                        config: _vm.config,
                        placeholder: "Select date",
                        red: "flatPickr",
                        "data-input": ""
                      },
                      model: {
                        value: _vm.licence.expiration_date,
                        callback: function($$v) {
                          _vm.$set(_vm.licence, "expiration_date", $$v)
                        },
                        expression: "licence.expiration_date"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "expiration_date" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Note")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.licence.note,
                        expression: "licence.note"
                      }
                    ],
                    staticClass: "form-control licence-note",
                    attrs: {
                      type: "text",
                      autocomplete: "no",
                      placeholder: "Enter comment",
                      disabled: !_vm.$_can("companies.update")
                    },
                    domProps: { value: _vm.licence.note },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.licence, "note", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "note" }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4982bfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4982bfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/mod24settings/CompaniesLicence.vue
// module id = null
// module chunks = 